// extracted by mini-css-extract-plugin
export default {"root":"_2PxQPO6iwkOWWF3SwYKX60"};